module.exports = __webpack_public_path__ + "img/phone-section-1.6c6524de.png";